var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCardCreatingIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1859 3.33325H14.8859C6.63594 3.33325 3.33594 6.63325 3.33594 14.8833V24.7833C3.33594 33.0333 6.63594 36.3333 14.8859 36.3333H24.7859C33.0359 36.3333 36.3359 33.0333 36.3359 24.7833V21.4833",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7351 5.03333L13.6018 18.1667C13.1018 18.6667 12.6018 19.65 12.5018 20.3667L11.7851 25.3833C11.5184 27.2 12.8018 28.4667 14.6184 28.2167L19.6351 27.5C20.3351 27.4 21.3184 26.9 21.8351 26.4L34.9684 13.2667C37.2351 11 38.3017 8.36666 34.9684 5.03333C31.6351 1.69999 29.0018 2.76666 26.7351 5.03333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8516 6.91669C25.4042 8.87913 26.4515 10.6668 27.8932 12.1084C29.3348 13.5501 31.1225 14.5974 33.0849 15.15",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCardCreatingIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/card-creating-icon.3b1e638b5b1bff93023b4884b354aee7.svg";